<template>
  <div class="users-list mt-10">
    <div class="text-h3 text-center mb-5">
      Listado de Usuarios
    </div>
    <v-data-table
      :headers="headers"
      :items="users"
      :items-per-page="10"
      class="elevation-1"
      :loading="loading"
      :search="search"
      loading-text="Cargando usuarios..."
      :footer-props="{
        itemsPerPageText: 'Usuarios por página',
        itemsPerPageAllText: 'Todos'
      }"
      :key="usersTableKey"
    >
      <template v-slot:top>
        <v-container class="d-flex align-center">
          <v-text-field
            v-model="search"
            label="Buscar"
            class="mx-4"
          ></v-text-field>
          <v-btn
            color="info"
            @click="toNewUserPage"
          >
            <v-icon
              class=""
              small
            >
              mdi-plus
            </v-icon>
            Crear Usuario
          </v-btn>
        </v-container>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn text depressed @click="editUser(item.userId)">
          <v-icon
            small
            class="mr-2"
          >
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn text depressed @click="deleteUser(item.userId)" :disabled="item.email === oidcUser.name">
          <v-icon
            small
          >
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      
    </v-data-table>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "UsersList",
  data() {
    return {
      search: '',
      loading: false,
      users: [],
      headers: [
        { text: 'E-mail', value: 'email' },
        { text: 'Nombres', value: 'firstName' },
        { text: 'Apellidos', value: 'lastName' },
        { text: 'Telefono', value: 'phoneNumber' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      usersTableKey:0
    }
  },
  mounted() { 
    this.loading = true;
    this.$cf_auth.getUsers().then(response=>{
      this.users.splice(0, this.users.length, ...response.data)
      this.loading = false
    }).catch(e=>{
      console.log('Error loading users: ',e)
      this.loading = false
    })
      /**/
  },
  computed:{
    ...mapGetters([
      'oidcUser'
    ]),
    user(){
      return this.oidcUser;
    }
  },
  methods:{
    toNewUserPage(){
      this.$router.push('/users/new')
    },
    deleteUser(userId){
      this.$cf_auth.deleteUser(userId).then(()=>{
        this.$store.dispatch('setSnack', 'Se ha desactivado usuario correctamente.')
        this.usersTableKey++
      }).catch(e=>{
        console.log('Error deleting user: ', e)
      })
    },
    editUser(userId){
      this.$router.push( '/users/' + userId +'/edit')
    }
  }
};
</script>